import { render, staticRenderFns } from "./CurationListDefaultLayout.vue?vue&type=template&id=7b17a33f&scoped=true"
import script from "./CurationListDefaultLayout.vue?vue&type=script&lang=js"
export * from "./CurationListDefaultLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b17a33f",
  null
  
)

export default component.exports